import React from 'react';
import { environment } from '../../environments/environment';
import { WizardProps } from '../components-v2/Wizard';
import { ExtendedTableData } from './getSisExtensionsData';
import { getOneRosterJob } from './getOneRosterJob';

declare let window: Window;

interface Window {
  DI_CONTEXT: {
    API_URL: string;
    HIGHSCHOOL_ID: string;
    STUDENT_URL: string;
    TOU_URI: string;
  };
  location: Location;
}
const { DI_CONTEXT, location } = window;

const getEnv = (): string => {
  if (location.origin.includes('succeed.naviance.com')) {
    return 'prod';
  } else {
    return 'qa';
  }
};

export const ONEROSTER_API_BASE_URL = `https://staff-api.${getEnv()}.staff.naviance.com`;

export const getOneRosterFileApiBaseUrl = (): string => {
  if (window.location.origin.includes("localhost")) {
    return "http://localhost:3000"; // Proxy server for localhost
  }
  return ONEROSTER_API_BASE_URL;
};

export const getOneRosterMetaData = async (
  setMetaValues?: (metaValues: Record<string, any>) => void
) => {
  try {
    const { data } = await getOneRosterJob();
    const metaValues = data.student?.metaValues || {};
    if (!metaValues) {
      return;
    }
    if (setMetaValues) {
      setMetaValues(metaValues);
    } else {
      return metaValues;
    }
  } catch (error) {
    console.error(error.message);
  }
};

export const API_URL = DI_CONTEXT?.API_URL || environment.API_URL;
export const BASE_PHOTO_URL = `https://${location.host}/studentsmain/photo.php`;

export const HIGHSCHOOL_ID = DI_CONTEXT?.HIGHSCHOOL_ID || '';
export const SIX_YEAR_HISTORY = 6;
export const UPLOAD_FILE_ENDPOINT = '/data-ingest/import-file';
export const CHANNEL_CONFIGURATIONS = '/data-ingest/configs/steps';

export const GET_CHANNEL_ENDPOINT = '/data-ingest/configs';

export const GET_COURSEPLANNER_CHANNEL_ENDPOINT = '/data-import/column-mappings/';

export const GET_PARAMETERGROUP_ENDPOINT = '/data-ingest/parametergroups';

export const TENANT_USER_ENDPOINT = 'data-ingest/tenantuser';
export const IMPORT_NAMES_ENDPOINT = 'data-ingest/configs/import-name';
export const ADD_EMAIL_ENDPOINT = 'data-ingest/configs/add-email';
export const REMOVE_EMAIL_ENDPOINT = 'data-ingest/configs/remove-email';
export const JOB_LOGS_ENDPOINT = 'data-ingest/jobs/logs';
export const ZONE_ENDPOINT = '/district/setupmain/zones.php';

export const TOS_ENDPOINT = '/district/tos.php';
export const PRIVACY_ENDPOINT =
  'https://ui-production.papaya.naviance.com/naviance-static-assets/html/policies/privacy.html';
export const TOU_ENDPOINT = 'https://ui-production.papaya.naviance.com/naviance-static-assets/html/policies/tou.html';

export const TestImportTypes = [
  { value: 'SAT_SUBJECT_V1', text: 'SAT Subject Test' },
  { value: 'course-catalog', text: 'Course Catalog' },
  { value: 'ACT_ASPIRE_V1', text: 'American College Testing Aspire Test' },
  {
    value: 'ACT_V1',
    text: 'Legacy American College Testing Test (taken before Oct 2015)',
  },
  { value: 'ACT_V2', text: 'American College Testing Test' },
  { value: 'AP_V1', text: 'Advanced Placement Test' },
  { value: 'EXPLORE_V1', text: 'EXPLORE College Readiness Test' },
  { value: 'IB_V1', text: 'IB Test' },
  { value: 'ISE_V1', text: 'Independent School Exam' },
  { value: 'PRE_ACT_V1', text: 'PreACT Test' },
  { value: 'PSAT_V1', text: 'Pre-2015 PSAT/NMSQT (taken before Oct 2015)' },
  { value: 'PSAT_V2', text: 'Preliminary SAT' },
  { value: 'SAT_V1', text: 'SAT Reasoning Test (before March 2016)' },
  { value: 'SAT_V2', text: 'SAT Reasoning Test' },
  { value: 'SSAT_V1', text: 'SSAT Independent School Admission Test' },
  {
    value: 'STATE_AZ_AIMS_V1',
    text: "Arizona's Instrument to Measure Standard",
  },
  { value: 'STATE_CA_CST_V1', text: 'California Standards Tests (CSTs)' },
  {
    value: 'STATE_CO_CSAP_V1',
    text: 'Colorado Student Assesment Program (CSAP)',
  },
  { value: 'STATE_CT_CAPT_V1', text: 'Connecticut Academic Performance Test' },
  {
    value: 'STATE_DC_CAS_V1',
    text: 'District of Columbia Comprehensive Assessment System (DC-CAS)',
  },
  { value: 'STATE_IN_CORE40_V1', text: 'Indiana Core 40 ECA' },
  {
    value: 'STATE_IN_ISTEP_V1',
    text: 'Indiana Statewide Testing for Educational Progress-Plus (ISTEP+)',
  },
  {
    value: 'STATE_MA_MCAS_V1',
    text: 'Massachusetts Comprehensive Assessment System',
  },
  { value: 'STATE_MN_MCA_V1', text: 'Minnesota Comprehensive Assessments' },
  {
    value: 'STATE_NJ_NJASK_V1',
    text: 'New Jersey Assessment of Skills and Knowledge',
  },
  {
    value: 'STATE_NJ_NJGEPA_V1',
    text: 'New Jersey Grade Eight Proficiency Assessment',
  },
  {
    value: 'STATE_NJ_NJHSPA_V1',
    text: 'New Jersey High School Proficiency Assessment',
  },
  { value: 'STATE_OH_OAT_V1', text: 'Ohio Achievement Test' },
  { value: 'STATE_OH_OGT_V1', text: 'Ohio Graduation Test' },
  {
    value: 'STATE_OR_OAKS_V1',
    text: 'Oregon Assessment of Knowledge and Skills (OAKS)',
  },
  {
    value: 'STATE_PA_PSSA_V1',
    text: 'Pennsylvania System of School Assessment (PSSA)',
  },
  { value: 'STATE_TX_EOC_V1', text: 'STAAR EOC (End of Course)' },
  {
    value: 'STATE_TX_STAAR_V1',
    text: 'State of Texas Assessments of Academic Readiness (STAAR)',
  },
  {
    value: 'STATE_TX_TAKS_V1',
    text: 'Texas Assessment of Knowledge and Skills (TAKS)',
  },
  { value: 'TERRA_NOVA_V1', text: 'TerraNova Standardized Achievement Test' },
  { value: 'TOEFL_V1', text: 'Test of English as a Foreign Language' },
];

export const PSError = 'PSError';

export enum ImportTypeParam {
  CourseCatalog = 'course-catalog',
  CourseMapping = 'course-mapping',
  StudentCourseData = 'student-course-data',
  Scholarship = 'SCHOLARSHIP_V1',
}

export const ImportTypeFileNames = {
  [ImportTypeParam.CourseCatalog]: 'CourseCatalog',
  [ImportTypeParam.CourseMapping]: 'CourseMapping',
  [ImportTypeParam.StudentCourseData]: 'StudentCourseData',
  [ImportTypeParam.Scholarship]: 'Scholarships',
};

export interface CoursePlannerImportData {
  importType: ImportTypeParam;
  file: File | null;
  saveSettings: boolean;
  importSettings: { overrideData: boolean };
  fileHeaders: string[];
  loading: boolean;
}

export enum StaffListType {
  teacher = 'Teacher',
  counselor = 'Counselor',
}

export enum StaffUserType {
  district = 'district',
  school = 'school',
}

export interface AvailableCodes extends ExtendedTableData {
  used?: boolean;
}

export const navDiplomaTypeData = [
  {
    description: 'Endorsed/Advanced Diploma',
    code: 'Endorsed/Advanced Diploma',
  },
  {
    description: 'General Education Development (GED) Credential',
    code: 'General Education Development (GED) Credential',
  },
  {
    description: 'High School Equivalency Credential (other than GED)',
    code: 'High School Equivalency Credential (other than GED)',
  },
  {
    description: 'International Baccalaureate',
    code: 'International Baccalaureate',
  },
  {
    description: 'Modified Diploma',
    code: 'Modified Diploma',
  },
  {
    description: 'Regular Diploma',
    code: 'Regular Diploma',
  },
  {
    description: 'Vocational Certificate',
    code: 'Vocational Certificate',
  },
  {
    description: 'Other',
    code: 'Other',
  },
];

export const navEthnicityData = [
  {
    description: 'N/A',
    code: 'UK',
  },
  {
    description: 'American Indian/Alaska Native',
    code: 'AI',
  },
  {
    description: 'Asian',
    code: 'AS',
  },
  {
    description: 'Black/African American',
    code: 'BA',
  },
  {
    description: 'Hispanic',
    code: 'HI',
  },
  {
    description: 'Multi Racial',
    code: 'MR',
  },
  {
    description: 'Pacific Islander/Native Hawaiian',
    code: 'PI',
  },
  {
    description: 'White',
    code: 'WH',
  },
];

export const cleverRaceCodes = [
  {
    description: 'Caucasian',
    code: 'Caucasian',
  },
  {
    description: 'Asian',
    code: 'Asian',
  },
  {
    description: 'Black or African American',
    code: 'Black or African American',
  },
  {
    description: 'American Indian',
    code: 'American Indian',
  },
  {
    description: 'Two or More Races',
    code: 'Two or More Races',
  },
  {
    description: 'Hawaiian or Other Pacific Islander',
    code: 'Hawaiian or Other Pacific Islander',
  },
  {
    description: 'Unknown',
    code: 'Unknown',
  },
];

export const oneRosterSISEthnicityCodes = [
  {
    code:'americanIndianOrAlaskaNative',
    description: 'American Indian or Alaska Native',
  },
  {
    description: 'Asian',
    code: 'asian',
  },
  {
    description: 'Black or African American',
    code: 'blackOrAfricanAmerican',
  },
  {
    description: 'Hispanic or Latino Ethnicity',
    code: 'hispanicOrLatinoEthnicity',
  },
  {
    description: 'Native Hawaiian or Other Pacific Islander',
    code: 'nativeHawaiianOrOtherPacificIslander',
  },
  {
    description: 'White',
    code: 'white',
  },
  {
    description: 'Demographic Race: Two or More Races',
    code: 'demographicRaceTwoOrMoreRaces',
  },
];

export const navFerpaBlockData = [
  {
    description: 'Yes',
    code: 'Y',
  },
  {
    description: 'No',
    code: 'N',
  },
];

export const navGenderData = [
  {
    description: 'Not Specified',
    code: 'U',
  },
  {
    description: 'Male',
    code: 'M',
  },
  {
    description: 'Female',
    code: 'F',
  },
  {
    description: 'Non-Binary',
    code: 'X',
  },
];

export const navGradeData = [
  {
    displayValue: '12',
    code: '12',
  },
  {
    displayValue: '11',
    code: '11',
  },
  {
    displayValue: '10',
    code: '10',
  },
  {
    displayValue: '9',
    code: '9',
  },
  {
    displayValue: '8',
    code: '8',
  },
  {
    displayValue: '7',
    code: '7',
  },
  {
    displayValue: '6',
    code: '6',
  },
  {
    displayValue: '5',
    code: '5',
  },
  {
    displayValue: '4',
    code: '4',
  },
  {
    displayValue: '3',
    code: '3',
  },
  {
    displayValue: '2',
    code: '2',
  },
  {
    displayValue: '1',
    code: '1',
  },
  {
    displayValue: 'K',
    code: '0',
  },
];

export const cleverGenderCodes = [
  {
    displayValue: 'Not Specified',
    code: '',
  },
  {
    displayValue: 'Male',
    code: 'M',
  },
  {
    displayValue: 'Female',
    code: 'F',
  },
  {
    displayValue: 'Non-Binary',
    code: 'X',
  },
];

export const cleverGradeCodes = [
  {
    displayValue: 'Preschool',
    code: 'preschool',
  },
  {
    displayValue: 'InfantToddler',
    code: 'infanttoddler',
  },
  {
    displayValue: 'TransitionalKindergarten',
    code: 'transitionalkindergarten',
  },
  {
    displayValue: 'PreKindergarten',
    code: 'prekindergarten',
  },
  {
    displayValue: '13',
    code: '13',
  },
  {
    displayValue: 'Other',
    code: 'other',
  },
  {
    displayValue: 'Ungraded',
    code: 'ungraded',
  },
  {
    displayValue: 'PostGraduate',
    code: 'postgraduate',
  },
];

export const naviancePrefixes = [
  {
    description: 'Dr.',
    code: 'Dr.',
  },
  {
    description: 'Mr.',
    code: 'Mr.',
  },
  {
    description: 'Ms.',
    code: 'Ms.',
  },
  {
    description: 'Mrs.',
    code: 'Mrs.',
  },
  {
    description: 'Miss',
    code: 'Miss',
  },
  {
    description: 'Sr.',
    code: 'Sr.',
  },
  {
    description: 'Fr.',
    code: 'Fr.',
  },
  {
    description: 'Br.',
    code: 'Br.',
  },
  {
    description: 'Rev.',
    code: 'Rev.',
  },
  {
    description: 'Mx.',
    code: 'Mx.',
  },
  {
    description: 'Other',
    code: 'Other',
  },
];

export const psSisMeta = {
  clientId: 'wbdfwefhebhbvhv',
  discoveryUrl: 'https://foo.com',
  host: 'https://foo.com',
  sisIntegration: 'psSis',
};

export const eSPMeta = {
  clientId: 'wbdfwefhebhbvhv',
  discoveryUrl: 'https://foo.com',
  host: 'https://foo.com',
  sisIntegration: 'eSP',
};

export const cleverMeta = {
  cleverId: 'wbdfwefhebhbvhv',
  clientId: 'wbdfwefhebhbvhv',
  dataHost: 'https://foo.com',
  host: 'https://foo.com',
  sisIntegration: 'clever',
};

export const translateConfig = {
  psStudentDataSyncConfig: { classRank: [], extensions: [] },
  translateConfig: {
    headerMappings: {
      student_number: 'hsStudentId',
      classof: ['classYear', 'originalClassYear'],
    },
  },
};

export const emptyFunc = (): any => {
  return;
};

export const props = (title: string): WizardProps => {
  return {
    steps: [{ title, status: 'process' }],
    currentStep: 0,
    saveFn: emptyFunc,
    cancelFn: emptyFunc,
    continueFn: emptyFunc,
    previousFn: emptyFunc,
    changeStepFn: emptyFunc,
    saveAndCloseFn: emptyFunc,
    children: <></>,
    hideFooter: true,
  };
};

export const gpaMethods = [
  { gpamethod: 'Simple' },
  { gpamethod: 'Simple Percent' },
  { gpamethod: 'SimpleCurrent' },
  { gpamethod: 'SimpleCurrent-Test' },
  {}, // API can return empty responses, so test that case.
];

export const DEFAULT_ROLL_OVER_DAY = 25;
export const DEFAULT_ROLL_OVER_MONTH = 7;

export const nonCleverIntegrations = ['psSis', 'eSP'];

export interface SignedURLData {
  url: string;
  bucketName: string;
  keyName: string;
  importId: number;
}

export const districtJobFunctions = [
  {
    description: 'N/A',
    code: 0,
  },
  {
    description: 'Counseling Director',
    code: 1,
  },
  {
    description: 'Counselor',
    code: 2,
  },
  {
    description: 'Technology Staff',
    code: 3,
  },
  {
    description: 'Support Staff',
    code: 4,
  },
  {
    description: 'Administrator',
    code: 5,
  }
];

export const schoolJobFunctions = [
  {
    description: 'Counseling Director',
    code: 1,
  },
  {
    description: 'Counselor',
    code: 2,
  },
  {
    description: 'Technology Staff',
    code: 3,
  },
  {
    description: 'Support Staff',
    code: 4,
  },
  {
    description: 'Administrator',
    code: 5,
  },
  {
    description: 'Teacher',
    code: 15,
  },
];

export const cleverSchoolUserTypes = [{
  label: 'Teacher',
  value: 'Teacher',
}, {
  label: 'Staff',
  value: 'Staff',
}]

export const cleverDistrictUserTypes = [{
    label: 'District Admin',
    value: 'District Admin',
}];

export enum JobFunctions {
  DISTRICT_DEFAULT = 0,
  SCHOOL_SUPPORT_STAFF = 4,
  SCHOOL_COUNSELOR = 2,
  SCHOOL_TEACHER = 15,
}

export const MAX_FILE_SIZE_BYTES = 1 * 1024 * 1024 * 1024; // 1GB
export const MAX_POLL_COUNT = 150; // 5 minutes max (150 * 2 seconds)
export const POLL_INTERVAL = 2000; // 2 seconds
export const BATCH_SIZE = 125; // For school mapping batches
export const EXPECTED_FILE_NAME = 'NavianceOneRoster';
export const ACCEPTED_FILE_EXTENSION = 'zip';
